import {Chip, type ChipProps} from '@mui/material';
import {getTagBorderColor, getTagSx, type TagColor} from './tag.styles';

const TAG_CLASS_NAME = 'MithraTag-root';

export type TagProps = Omit<ChipProps, 'color'> & {
    color?: TagColor;
    /** Solid uses the strong tag colors; otherwise the pale theme chip colors with a light border. */
    solid?: boolean;
};

/** Tag is a Chip preset for tag and filter use cases. */
export const Tag = ({
                        color = 'info',
                        size = 'small',
                        variant = 'filled',
                        solid = true,
                        className,
                        sx,
                        ...props
                    }: TagProps) => {
    const sxList = Array.isArray(sx) ? sx : sx ? [sx] : [];

    if (!solid) {
        return (
            <Chip
                className={className}
                color={color}
                size={size}
                variant={variant}
                sx={[{minHeight: 24, border: '1px solid', borderColor: getTagBorderColor(color), '&&': {borderRadius: 1}}, ...sxList]}
                {...props}
            />
        );
    }

    return (
        <Chip
            className={className ? `${TAG_CLASS_NAME} ${className}` : TAG_CLASS_NAME}
            color="default"
            size={size}
            variant={variant}
            sx={[getTagSx(color, variant), {minHeight: 24, '&&': {borderRadius: 1}}, ...sxList]}
            {...props}
        />
    );
};
